import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetAssessmentUserSkillScoresArgsType = GetRequestArgsType & {
  assessmentId: number;
};

export type AssessmentUserSkillScoresFileSerializerType = {
  inputFile: File;
};

export type PostAssessmentUserSkillScoresFileArgsType = (
  PostRequestArgsType<AssessmentUserSkillScoresFileSerializerType>
) & {
  assessmentId: number;
};

export const apiFetchAssessmentUserSkillScores = async ({
  domain = useTenantStore().domain,
  assessmentId,
  query = {},
  errorConfig = {},
  callbacks = {},
}: GetAssessmentUserSkillScoresArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.assessmentUserSkillScores({
        domain,
        assessmentId,
      }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiUploadAssessmentUserSkillScoresFile = async ({
  domain = useTenantStore().domain,
  assessmentId,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostAssessmentUserSkillScoresFileArgsType) => {
  const impl = async () => {
    const formData = new FormData();
    formData.append('inputFile', payload.inputFile);

    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.assessmentUserSkillScoresFile({
        domain,
        assessmentId,
      }),
      payload: formData,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
